import useSWRMutation from 'swr/mutation';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import { APIError } from 'APIs/types';
import {
  updateLocalUser,
  updateLocalUserProfile,
  setUserData,
} from 'utils/functions/getUserData';
import { ResetPassword, User, UserData, UserProfile } from './types';

export function fetchUserDataRequest() {
  return useSWRMutation<UserData, Error, string, null>(
    `/api/v1/me/`,
    async (url) => {
      return letrusAPI(url, { method: 'get' }).then((response) => {
        setUserData(response.data);

        return response.data;
      });
    },
    { throwOnError: false }
  );
}

export function updateUserRequest() {
  return useSWRMutation<User, Error, string, Partial<User>>(
    `/api/v1/users`,
    async (url, { arg: { id, ...profileData } }) => {
      return letrusAPI(`${url}/${id}/`, {
        method: 'patch',
        data: profileData,
      }).then((response) => {
        updateLocalUser(response.data);

        return response.data;
      });
    },
    { throwOnError: false }
  );
}

export function updateUserProfileRequest() {
  return useSWRMutation<UserProfile, Error, string, Partial<UserProfile>>(
    `/api/v1/user_profile`,
    async (url, { arg: { id, ...profileData } }) => {
      return letrusAPI(`${url}/${id}/`, {
        method: 'patch',
        data: profileData,
      }).then((response) => {
        updateLocalUserProfile(response.data);

        return response.data;
      });
    },
    { throwOnError: false }
  );
}

export function resetPasswordRequest() {
  return useSWRMutation<void, APIError, string, ResetPassword>(
    '/api/v1/users',
    (url, { arg: { id, ...passwordData } }) =>
      letrusAPI(`${url}/${id}/reset_password/`, {
        method: 'post',
        data: passwordData,
      }).then((res) => res.data),
    { throwOnError: false }
  );
}
